@if (dataSource && dataSource.length > 0) {
  <div>
    <div class="flex flex-row justify-start gap-2 items-start">
      @if (!permissionService.hasProjectPrivilege('PROJECT_TASK_EDIT')) {
        <div [tooltip]="'Keine Berechtigung'">
          <button mat-raised-button disabled>Aufgabe erstellen</button>
        </div>
      } @else {
        <button (click)="createNewTask()" mat-raised-button>Aufgabe erstellen</button>
      }
      <button (click)="importBCFClicked.emit()" mat-raised-button>BCF importieren</button>
    </div>
    <div class="bg-white rounded-md shadow-full overflow-hidden overflow-y-scroll max-h-[80vh] mt-4 mx-3">
      <table #tasksTbSort="matSort" [dataSource]="dataSource" mat-table matSort>
        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
          <td *matCellDef="let element" mat-cell> {{ element.markup?.topic?.atGuid }}</td>
        </ng-container>
        <!-- title Column -->
        <ng-container matColumnDef="title">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Titel</th>
          <td *matCellDef="let element" mat-cell>
            <div class="line-clamp-2 pr-6">
              {{ element.markup?.topic?.title }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="prio">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Priorität</th>
          <td *matCellDef="let element" mat-cell>
            <div
              [ngClass]="{'high': element.priority === priorityEnum.HIGH, 'normal': element.priority === priorityEnum.NORMAL, 'low' : element.priority === priorityEnum.LOW}">
            {{element.priority | priority }}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="projectName">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Leistungsphase</th>
          <td *matCellDef="let element" mat-cell>{{ element.lph }}</td>
        </ng-container>
        <!-- deadline Column -->
        <ng-container matColumnDef="deadline">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Deadline</th>
          <td *matCellDef="let element" mat-cell> {{ $safeNavigationMigration(element.markup?.topic?.dueDate) | date: "dd.MM.yyyy" }}</td>
        </ng-container>
        <!-- state Column -->
        <ng-container matColumnDef="state">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Status</th>
          <td *matCellDef="let element" mat-cell> {{ element.state | taskState }}</td>
        </ng-container>
        <!-- people Column -->
        <ng-container matColumnDef="people">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Bearbeiter*in</th>
          <td *matCellDef="let element" mat-cell>
            {{ element.markup?.topic?.creationUser?.firstName }} {{ element.markup?.topic?.creationUser?.lastName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="createdBy">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Erstellt von</th>
          <td *matCellDef="let element" mat-cell>
            @if (element.markup?.topic?.creationUser) {
              {{ element.markup?.topic?.creationUser?.firstName }} {{ element.markup?.topic?.creationUser?.lastName }}
            }
            @if (!element.markup?.topic?.creationUser) {
              {{ element.markup?.topic?.creationAuthor }}
            }
          </td>
        </ng-container>
        <!-- create Column -->
        <ng-container matColumnDef="date">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Erstellt</th>
          <td *matCellDef="let element"
              mat-cell> {{ $safeNavigationMigration(element.markup?.topic?.creationDate) | date: "dd.MM.yyyy - HH:mm" }}
          </td>
        </ng-container>
        <!-- state Column -->
        <ng-container matColumnDef="project">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Projekt</th>
          <td *matCellDef="let element" mat-cell> {{ element.projectName }}</td>
        </ng-container>
        <!-- actions Column -->
        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef mat-header-cell></th>
          <td *matCellDef="let element" class="!text-end" mat-cell>
            <button (click)="$event.stopPropagation()" [matMenuTriggerData]="{task: element}" [matMenuTriggerFor]="menu" class="pr-2"
                    mat-icon-button>
              <fa-icon [icon]="faEllipsisVertical" class="text-green text-xl"></fa-icon>
            </button>
            <!--button mat-icon-button matTooltip="Öffnen" (click)="selectTask(element)">
            <mat-icon>open_in_new</mat-icon>
          </button-->
        </td>
      </ng-container>
      <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;" mat-row
            (dblclick)="permissionService.hasProjectPrivilege('PROJECT_TASK_EDIT') && selectTask(row)"></tr>
    </table>
    <!--mat-paginator class="mat-paginator-sticky" [length]="task_length" [pageSize]="default_page_size"
  [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons></mat-paginator-->
    </div>
</div>
}

@if (dataSource && dataSource.length == 0) {
  <app-empty-state [icon]="faCircleInfo" message="Noch keine Aufgaben erstellt">
    <bic-button (onClick)="createNewTask()" buttonType="white">
      Task erstellen
      <fa-icon [icon]="faClipboardCheck" iconLeft></fa-icon>
    </bic-button>
  </app-empty-state>
}


<mat-menu #menu="matMenu">
  <ng-template matMenuContent let-task="task">
    @if (!permissionService.hasProjectPrivilege('PROJECT_TASK_EDIT')) {

      <div [tooltip]="'Keine Berechtigung'">
        <button mat-menu-item disabled>Bearbeiten</button>
      </div>
    
} @else {

      <button mat-menu-item (click)="selectTask(task)">Bearbeiten</button>
    
}
    

    <button mat-menu-item (click)="exportBCFClicked.emit(task)">
      BCF-Export
    </button>

    @if (!permissionService.hasProjectPrivilege('PROJECT_TASK_DELETE')) {

      <div [tooltip]="'Keine Berechtigung'">
        <button mat-menu-item disabled style="color: gray">Löschen</button>
      </div>
    
} @else {

      <button mat-menu-item style="color: red" (click)="openDeleteDialog(task)">Löschen</button>
    
}
    
  </ng-template>
</mat-menu>
